import { FormikSelect } from 'components/Form';
import { FieldProps } from 'formik';
import { getNestedError } from 'helpers/formikHelper';
import * as React from 'react';
import { ContactType } from '../types/contact';
import { useTranslation } from 'react-i18next';

type Props = {
  fieldProps: FieldProps;
  label?: string;
};

const ContactTypesSelect: React.FunctionComponent<Props> = ({ label, fieldProps: { field, form } }: Props) => {
  const { t } = useTranslation('global');

  return (
    <FormikSelect
      label={label}
      isMulti
      field={field}
      form={form}
      options={[...Object.values(ContactType)]}
      getOptionValue={(option) => option}
      getOptionLabel={(option) => t(`contactTypes.${option}`)}
      error={getNestedError(field.name, form.errors, form.touched)}
    />
  );
};

export default ContactTypesSelect;
